import Vue from 'vue'
import Vuex from 'vuex'
import { userManageApi } from '../apis/userManageApi'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // http请求进度，用于处理页面是否显示loading  1：已发起http请求   2：http请求已完成
    httpProgress: 0,
    // 当前页面的面包屑数据
    breadCrumbList: [],
    // 患者详情页面的患者信息
    patientInfo: null
  },
  getters: {

  },
  mutations: {
    updateHttpProgress (state, data) {
      state.httpProgress = data
    },
    updateBreadCrumbList (state, data) {
      state.breadCrumbList = data
    },
    updatePatientInfo (state, data) {
      state.patientInfo = data
    }
  },
  actions: {
    // 获取患者详情
    getUserDetail (context, patientId) {
      const params = {
        patientId
      }
      userManageApi.getUserDetail(params).then(res => {
        const {code, message, content} = res
        if (code !== '200') {
          console.log(`获取患者详情失败，原因：${message}`)
          return false
        }
        context.commit('updatePatientInfo', content)
      }, error => {
        console.log(`获取患者详情失败，原因：${JSON.stringify(error)}`)
      }).catch(error => {
        console.log(`获取患者详情失败，原因：${JSON.stringify(error)}`)
      })
    }
  },
  modules: {

  }
})



// WEBPACK FOOTER //
// ./src/store/index.js